import React, { createRef } from "react";
import BaseComponent from "../../../../../base/common/BaseComponent";
import ProcedureBlock from "../../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../../sections/taskInfoSections";
import ProcedureInformation from "../../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import Buttons from "../../../../../base/basicComponents/button";
import { ModalWithComponent } from "../../../../../base/basicComponents/modal";
import { actions, dataStatus, fileTags } from "../../../../publicDictionaryValues";
import CreateSupportingFileReviseSection from "../../../../sections/supportingFileSections/createSupportingFileReviseSection";
import ReadOnlyProcedureFileSection from "../../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import createSupportingFileService from "../../../../../service/supportingFile/createSupportingFileService";
import styles from "../../style/index.module.scss";
import ActiveShareTaskReadOnly from "../../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import appService from "../../../../../service/app";
import LostPermissionModal from "../../../../sections/lostPermissionModal";
import StepService from "../../../../../service/stepBase/StepService";
import StepBusinessType from "../../../../../service/stepBase/stepBusinessType";

const supportingReturnAddFileRef = createRef();
const reasonRef = createRef();
const noteRef = createRef();
const procedureFileRef = createRef();
const supportingFileRef = createRef();
const supportingFileTableRef = createRef();

export default class ReviseNewSupportingFilePending extends BaseComponent {
  constructor(props: any) {
    super(props);
    const { rejectReason, rejectStatus } = this.props.pageProps;
    this.state = {
      pageState: {
        rejectReason,
        rejectStatus,
        isCancelDisabled: false,
        isSubmitDisabled: false,
        isRejectDisabled: false,
        isTableBorderError: false,
        isChange: false,
      },
      modalState: {
        modalTitle: "",
        modalLabel: "",
        okText: "",
        cancelText: "",
        closable: false,
        isOkBtnDisabled: false,
        isCancelBtnDisabled: false,
        maskClosable: false,
        isModalWithComponentOpen: false,
        isShowSelect: false,
        rowIndex: 0,
        fileIds: [],
        fileNames: [],
        modalWidth: 520,
      },
      noPermission: false,
    };
    // @ts-ignore
    this.para = null;
    // @ts-ignore
    this.isTableBorderError = false;
    // @ts-ignore
    this.isSaveDisabled = true;
    // @ts-ignore
    this.modalContentLabels = {
      cancelConfimModalLabel: (
        <span className={styles.modalText}>Are you sure to quit without saving?</span>
      ),
      submitConfirmModalLabel: <span className={styles.modalText}>Are you sure to submit?</span>,
    };
    // @ts-ignore
    this.params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };
  }

  /* function about get data from procedure file table */
  returnFileDataValue = (name: any, index: any) => {
    const supportingFileData = this.props.supportingRef.current.getDataList();
    let deleteList = this.props.supportingRef.current.getDeleteList();
    let combineDatalist = supportingFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  /* success callback about click submit or save button to trigger api */
  _triggerReviseNewSupportingFilePendingSuccess = (response: any) => {
    if (response.succeeded === false) {
      console.log(response.message);
    } else {
      this.props.closePage();
    }
    this.props._hideLoading();
  };

  /* error callback about click submit or save button to trigger api */
  _triggerReviseNewSupportingFilePendingError = (response: any) => {
    console.log(response);
  };

  /* function about click submit or save button to trigger api */
  createSupportingFileTriggerAction = () => {
    createSupportingFileService.createSupportingFileTriggerRevisePageAction(
      // @ts-ignore
      this.para,
      this._triggerReviseNewSupportingFilePendingSuccess,
      this._triggerReviseNewSupportingFilePendingError
    );
  };

  setReviseNewSupportingFilePendingSubmitDisabled = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isSubmitDisabled: true,
      },
    });
  };

  handleReviseNewSupportingFilePendingSubmitTriggerAction = () => {
    // @ts-ignore
    this.para = this.props.handleReturnSubmitData(
      actions.revise,
      "Revise",
      this.props.supportingRef
    );
    this.createSupportingFileTriggerAction();
  };

  /* function about click submit button in submit modal */
  handleReviseNewSupportingFilePendingSubmitOkClick = () => {
    let isReviseNewSupportingFilePendingTableDataReturn = false;
    this.setReviseNewSupportingFilePendingSubmitDisabled();
    this.props._showLoading();
    this.hideReviseNewSupportingFilePendingModal();
    try {
      this.props.data.forEach((fileData: any, index: any) => {
        const file = fileData.data.find((item: any) => item.name === "fileName");
        const statusData = fileData.data.find((item: any) => item.name === "status");
        isReviseNewSupportingFilePendingTableDataReturn =
          statusData.value === dataStatus.return && file.tagValue !== fileTags.deleted;
        if (isReviseNewSupportingFilePendingTableDataReturn) {
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }

    this.handleReviseNewSupportingFilePendingSubmitTriggerAction();
  };

  /* function about click submit button in cancel action modal */
  handleReviseNewSupportingFilePendingCancelOkClick = () => {
    this.setState({
      pageState: { ...this.state.pageState, isCancelDisabled: true },
    });
    this.hideReviseNewSupportingFilePendingModal();
    this.props.closePage();
  };

  handleReviseNewSupportingFilePendingCancelClick = () =>
    this.handleReviseNewSupportingFilePendingCreateActionClickSectionCheckModal(
      "",
      // @ts-ignore
      this.modalContentLabels.cancelConfimModalLabel,
      this.handleReviseNewSupportingFilePendingCancelOkClick,
      this.hideReviseNewSupportingFilePendingModal
    );

  /* function about close modal */
  hideReviseNewSupportingFilePendingModal = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: false,
        modalLabel: "",
        isShowTextAreaAndUploadDragger: false,
        modalTitle: "",
        uploadDraggerFileType: "",
        modalWidth: 520,
        isShowSelect: false,
        fileNames: [],
        textAreaClassName: "",
        textAreaMaxLength: 0,
        textAreaPlacement: "",
        maskClosable: false,
        isShowTextArea: false,
        actionType: "",
        fileIds: [],
      },
    });
  };

  /* function about click submit button in revise page to show the tip modal */
  handleReviseNewSupportingFilePendingCreateActionClickSectionCheckModal = (
    modalTitle: any,
    modalLabel: any,
    okMethod: any,
    cancelMethod: any
  ) => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        cancelText: "Cancel",
        isModalWithComponentOpen: true,
        handleCancel: cancelMethod,
        modalTitle: modalTitle,
        modalWidth: 520,
        okText: "Confirm",
        handleOk: okMethod,
        modalLabel: modalLabel,
      },
    });
  };

  handleReviseNewSupportingFilePendingControlErrorScroll = (top: any) =>
    window.scrollTo(0, top || 0);

  /* function about click submit button in revise page to scroll page if table has error */
  constrolTableScrollWhenSubmit = (
    isTableError: any,
    procedureFileData: any,
    errorIndexList: any,
    ref: any
  ) => {
    if (isTableError) {
      // @ts-ignore
      if (this.isTableBorderError) {
        procedureFileData.forEach((item: any, index: any) => {
          procedureFileData[index].isError = true;
        });
        const tableEle = document.getElementsByClassName("approveSupportingTable")[0];
        tableEle !== undefined &&
          this.handleReviseNewSupportingFilePendingControlErrorScroll(
            // @ts-ignore
            tableEle.offsetTop + tableEle.clientHeight
          );
        // @ts-ignore
        this.isTableBorderError = true;
        this.setState({
          pageState: { ...this.state.pageState, isTableBorderError: true },
        });
      } else {
        const firstErrorTr = document.getElementById(`table-tr-${errorIndexList[0]}`);
        this.handleReviseNewSupportingFilePendingControlErrorScroll(
          // @ts-ignore
          firstErrorTr.offsetTop + firstErrorTr.clientHeight
        );
      }
      ref.current.updateDataList(procedureFileData);
    } else {
      procedureFileData.forEach((item: any, index: any) => {
        procedureFileData[index].isError = false;
      });
      this.handleReviseNewSupportingFilePendingCreateActionClickSectionCheckModal(
        "",
        // @ts-ignore
        this.modalContentLabels.submitConfirmModalLabel,
        this.handleReviseNewSupportingFilePendingSubmitOkClick,
        this.hideReviseNewSupportingFilePendingModal
      );
    }
  };

  /* function about click submit button in revise page if returned files don't do change */
  handleCheckFileTableHighLight = (
    supportingFileData: any,
    tableErrorList: any,
    isTableError: any
  ) => {
    let errorIndexList = [];
    let deleteList = [];
    if (supportingFileData.length === 0) {
      isTableError = true;
      // @ts-ignore
      this.isTableBorderError = true;
      this.setState({
        pageState: { ...this.state.pageState, isTableBorderError: true },
      });
    } else if (supportingFileData.length === 1) {
      const isReturned =
        supportingFileData[0].data.find((file: any) => file.name === "status").value ===
        dataStatus.return;
      const fileTag = supportingFileData[0].data.find(
        (file: any) => file.name === "fileName"
      ).tagValue;
      if (isReturned && fileTag !== (fileTags.replaced || fileTags.deleted)) {
        errorIndexList = [];
        tableErrorList.push(supportingFileData[0]);
        isTableError = true;
        supportingFileData[0].isError = true;
        errorIndexList.push(0);
      }
    } else {
      supportingFileData.map((fileData: any, index: any) => {
        const isReturned =
          fileData.data.find((file: any) => file.name === "status").value === dataStatus.return;
        const fileTag = fileData.data.find((file: any) => file.name === "fileName").tagValue;
        const isReviewed = fileData.data.find((file: any) => file.name === "isReviewed").value;
        if (isReturned && !isReviewed && fileTag !== fileTags.deleted) {
          errorIndexList = [];
          tableErrorList.push(supportingFileData[index]);
          errorIndexList.push(index);
          isTableError = true;
          supportingFileData[index].isError = true;
        } else if (fileTag === fileTags.deleted) {
          deleteList.push(index);
        }
      });
      if (
        tableErrorList.length === supportingFileData.length ||
        deleteList.length === supportingFileData.length
      ) {
        // @ts-ignore
        this.isTableBorderError = true;
        this.setState({
          pageState: { ...this.state.pageState, isTableBorderError: true },
        });
        isTableError = true;
      } else if (tableErrorList.length > 0 && tableErrorList.length !== supportingFileData.length) {
        // @ts-ignore
        this.isTableBorderError = false;
        this.setState({
          pageState: { ...this.state.pageState, isTableBorderError: false },
        });
        isTableError = true;
      }
    }
    this.constrolTableScrollWhenSubmit(
      isTableError,
      supportingFileData,
      errorIndexList,
      supportingFileTableRef
    );
  };

  /* function about click submit button in revise page */
  handleReviseSubmitClickCheck = (procedureFileData: any, tableErrorList: any) => {
    let isTableError = false;
    this.handleCheckFileTableHighLight(procedureFileData, tableErrorList, isTableError);
  };

  _checkStepPermissionSuccess = (result: any, actionType: any) => {
    this.props._hideLoading();
    const { statusCode } = result;
    const noPermission = statusCode !== 200;
    this.setState({
      noPermission,
    });
    if (noPermission) return;
    if (actionType === "submit") {
      this.handleSubmitClick();
    } else if (actionType === "save") {
      this.handleSaveClick();
    }
  };

  checkStepPermission = (actionType: any) => {
    this.props._showLoading();
    const param = {
      taskID: this.props.params.ProcedureTaskId,
      procedureID: this.props.params.ProcedureID,
      procedureStepID: this.props.params.ProcedureStepID,
      parentPage: null,
    };
    appService.checkStepPermission(
      param,
      (response: any) => this._checkStepPermissionSuccess(response, actionType),
      (response: any) => console.log(response.message)
    );
  };

  /* function about click submit button in approve page */
  handleSubmitClick = () => {
    const supportingFileData =
      this.props.supportingRef.current === null
        ? []
        : this.props.supportingRef.current.getDataList();
    let tableErrorList: any[] = [];
    let isTableError = false;
    this.handleCheckFileTableHighLight(supportingFileData, tableErrorList, isTableError);
  };

  /* function about click save button */
  handleSaveClick = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        actionID: actions.save,
      },
    });
    // @ts-ignore
    this.isSaveDisabled = true;
    this.props._showLoading();
    // @ts-ignore
    this.para = this.props.handleReturnSubmitData(actions.save, "Save", this.props.supportingRef);

    this.createSupportingFileTriggerAction();
  };

  /* function about control save button disable when procedure file table change */
  setIsTableChange = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isChange: true,
      },
    });
  };

  /* function about control save button disable when procedure file table change */
  cancelIsTableChange = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isChange: false,
      },
    });
  };

  /**
   * function about return page name
   * @returns
   */
  handleReturnTitle = () => {
    return "Revise New Supporting File";
  };

  /**
   * function about return revision information section
   * @returns
   */
  handleReturnRevisionInformation = () => {
    return null;
  };

  handleChangeTableErrorStatus = (value: any) => {
    // @ts-ignore
    this.isTableBorderError = value;
    this.setState({
      pageState: {
        ...this.state.pageState,
        isTableBorderError: value,
      },
    });
  };

  handleReturnSupportingFileSection = (obj: any) => {
    const { currentRole, supportingReplaceFileRef, isDisableAll, isTableBorderError } = obj;

    this.props.data.forEach((item: any) => {
      const tagValue = item.data.find((item: any) => item.name === "fileName").tagValue;
      if (tagValue === fileTags.deleted) {
        item.data.find((item: any) => item.name === "note").isDisabled = true;
      }
      return item;
    });

    return (
      <ProcedureBlock
        testid="supporting-file-block-arrow"
        className={styles.approveSupportingFile}
        child={
          <CreateSupportingFileReviseSection
            sectionProps={{ currentRole }}
            setIsTableChange={this.setIsTableChange}
            initProcedureFileTableState={this.props.initProcedureFileTableState}
            cancelIsTableChange={this.cancelIsTableChange}
            initSupportingTableData={this.props.initSupportingTableData}
            updateUploadProcedureFileNum={this.props.updateUploadProcedureFileNum}
            refs={{
              supportingFileTableRef,
              noteRef,
              supportingReplaceFileRef,
              supportingFileRef,
              reasonRef,
              supportingRef: this.props.supportingRef,
            }}
            data={this.props.data}
            isTableBorderError={isTableBorderError}
            handleChangeTableErrorStatus={this.handleChangeTableErrorStatus}
            _hideLoading={this.props._hideLoading}
            updateSupportingFileNum={this.props.updateSupportingFileNum}
            isDisableAll={isDisableAll}
            _showLoading={this.props._showLoading}
          />
        }
        isOpen={true}
        isShowArrow={true}
      />
    );
  };

  handleReturnProcedureFileSection = () => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureFile}
        child={
          <ReadOnlyProcedureFileSection
            procedureFileRef={procedureFileRef}
            clientServerPath={this.props.serverPathValue}
            savedInRadioValue={this.props.savedInRadioValue}
            procedureFileData={
              this.props.sectionProps.fileTableData !== undefined
                ? this.props.sectionProps.fileTableData
                : []
            }
            jbProcedureSavedIn={this.props.sectionProps.jbProcedureSavedIn}
          />
        }
        isShowArrow={true}
        isOpen={false}
        testid="procedure-file-block-arrow"
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureFileData,
            this.setError,
            [StepBusinessType.procedureFile]
          );
        }}
      />
    );
  };

  handleReviseNewSupportingFilePendingProcedureInformation = () => {
    const { procedureStatus } = this.props.pageProps;
    const { procedureInfoData, ppoList } = this.props.sectionProps;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ProcedureInformation
            isShowActions={false}
            noteDisabled={true}
            ppoList={ppoList}
            procedureStatus={procedureStatus}
            isPPODisabled={true}
            submitData={procedureInfoData}
            title="Procedure Information"
          />
        }
        isShowArrow={true}
        isOpen={false}
        testid="procedure-info-block-arrow"
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureInfoData,
            this.setError,
            [
              StepBusinessType.procedureOwner,
              StepBusinessType.pmpExcluded,
              StepBusinessType.primaryProcedureOwner,
            ]
          );
        }}
      />
    );
  };

  handleReviseNewSupportingFilePendingShareTaskSection = () => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<ActiveShareTaskReadOnly shareTaskData={this.props.shareTaskData} />}
        isShowArrow={true}
        isOpen={false}
        testid="share-task-block-arrow"
        onShowDataLoad={() => {
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setShareTaskData,
            this.setError,
            [StepBusinessType.shareTask],
            StepService.getMergePayloadBySettingKey([StepBusinessType.shareTask.settingKey])
          );
        }}
      />
    );
  };

  handleReviseNewSupportingFilePendingButton = () => {
    const { isCancelDisabled, isSubmitDisabled, isChange } = this.state.pageState;

    return (
      <div className={styles.actionBtns}>
        <div className={styles.normalBtns}>
          <Buttons
            testid="revise-supporting-file-save-btn"
            color="grey"
            size="middle"
            onClick={() => this.checkStepPermission("save")}
            disabled={!isChange}
            btnClassName={styles.approveActionBtn}
          >
            Save as Draft
          </Buttons>
          <Buttons
            testid="revise-supporting-file-cancel-btn"
            color="grey"
            size="middle"
            onClick={this.handleReviseNewSupportingFilePendingCancelClick}
            disabled={isCancelDisabled}
            btnClassName={styles.approveActionBtn}
          >
            Cancel
          </Buttons>
          <Buttons
            testid="revise-supporting-file-submit-btn"
            color="blue"
            size="middle"
            onClick={() => this.checkStepPermission("submit")}
            disabled={isSubmitDisabled}
            btnClassName={styles.approveActionSubmitBtn}
          >
            Submit for Approval
          </Buttons>
        </div>
      </div>
    );
  };

  handleReviseNewSupportingFilePendingModalWithComponent = () => {
    const { supportingReplaceFileRef } = this.props.pageProps;
    const {
      modalTitle,
      modalLabel,
      closable,
      modalWidth,
      handleOk,
      handleCancel,
      isOkBtnDisabled,
      isCancelBtnDisabled,
      maskClosable,
      isModalWithComponentOpen,
      rowIndex,
      okText,
      cancelText,
      fileIds,
      fileNames,
    } = this.state.modalState;

    return (
      // @ts-ignore
      <ModalWithComponent
        testid="revise-supporting-file-modal"
        isModalOpen={isModalWithComponentOpen}
        cancelText={cancelText}
        fileNames={fileNames}
        closable={closable}
        title={modalTitle}
        handleOk={handleOk}
        handleCancel={handleCancel}
        isOkDisabled={isOkBtnDisabled}
        isLoading={isOkBtnDisabled}
        modalWidth={modalWidth}
        isCancelDisabled={isCancelBtnDisabled}
        maskClosable={maskClosable}
        label={modalLabel}
        fileUploadRef={supportingReplaceFileRef}
        fileUploadInputRef={supportingReturnAddFileRef}
        okText={okText}
        hideLoading={(this as any)._hideModalBtnsDisabled}
        openLoading={(this as any)._openModalBtnsDisabled}
        rowindex={rowIndex}
        fileIds={fileIds}
      />
    );
  };

  render() {
    const { receiveDate, requestByName, currentRole, supportingReplaceFileRef, isDisableAll } =
      this.props.pageProps;

    const { isTableBorderError } = this.state.pageState;
    const { taskInfoData } = this.props.sectionProps;

    return (
      <div className={styles.approveNewPro}>
        <PageHeader
          title={this.handleReturnTitle()}
          receiveDate={this._formateDate(receiveDate)}
          requestBy={requestByName}
          status="Pending"
        />
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<TaskInformation data={taskInfoData} />}
          isShowArrow={true}
          isOpen={false}
          testid="task-info-block-arrow"
          onShowDataLoad={() => {
            return StepService.getStepData(
              // @ts-ignore
              this.params,
              this.props.setTaskInfoData,
              this.setError,
              [StepBusinessType.taskInfo],
              StepService.getMergePayloadBySettingKey([StepBusinessType.taskInfo.settingKey])
            );
          }}
        />
        {this.handleReturnRevisionInformation()}
        {this.handleReturnProcedureFileSection()}
        {this.handleReturnSupportingFileSection({
          currentRole,
          supportingReplaceFileRef,
          isTableBorderError,
          isDisableAll,
        })}
        {this.handleReviseNewSupportingFilePendingProcedureInformation()}
        {this.handleReviseNewSupportingFilePendingShareTaskSection()}
        {this.handleReviseNewSupportingFilePendingButton()}
        {this.handleReviseNewSupportingFilePendingModalWithComponent()}
        <LostPermissionModal isModalOpen={this.state.noPermission} />
      </div>
    );
  }
}
